import { LazyExoticComponent } from 'react'

import Dashboard from './Dashboard'
import AccessControl from './AccessControl'
import AlarmEvent from './AlarmEvent'
import FlowControl from './FlowControl'
import Gateway from './Gateway'
import StatisticalAnalysis from './StatisticalAnalysis'
import ReportFormsAnalysis from './ReportFormsAnalysis'
import QosPlot from './QosPlot'
import SubUser from './SubUser'
import OperationLog from './OperationLog'
import OpenService from './OpenService'
import NetworkTopology from './NetworkTopology'
import PopServers from './CMI/PopServers'
import UserOrder from './CMI/UserOrder'
import OpLog from './CMI/OperationLog'
import PrivateLine from './CMI/PrivateLine'
import NetTopology from './CMI/NetworkTopology'
import SaasAcceleration from './CMI/SaasAcceleration'
import FlowLog from './CMI/FlowLog'
import CrossBorder from './CMI/CrossBorder'
import DialTest from './CMI/DialTest'

interface RouteItem {
  key: string
  path: string
  component: LazyExoticComponent<any>
}

const routes: RouteItem[] = [
  // { key: 'dashboard', path: '/dashboard', component: Dashboard },
  { key: 'network-topology', path: '/NetworkTopology/index', component: NetworkTopology.Container },
  { key: 'gateway-list', path: '/gateway', component: Gateway.List },
  { key: 'gateway-detail', path: '/gateway/detail/:id', component: Gateway.Detail },
  { key: 'access-control-control', path: '/access-control/control', component: AccessControl.Control },
  { key: 'access-control-create', path: '/access-control/control/create', component: AccessControl.CreateRule },
  { key: 'qos-plot-control', path: '/qos-plot/control', component: QosPlot.ControlPlot },
  { key: 'qos-plot-create', path: '/qos-plot/control/create', component: QosPlot.CreatePlot },
  { key: 'alarmevent-list', path: '/alarm-event/list', component: AlarmEvent.List },
  { key: 'flow-record', path: '/flow-control/record', component: FlowControl.FlowRecord },
  { key: 'control-log', path: '/flow-control/log', component: FlowControl.ControlLog },
  { key: 'statistical-analysis', path: '/statistical-analysis/detail', component: StatisticalAnalysis.Detail },
  { key: 'report-forms-analysis-list', path: '/report-forms-analysis/list', component: ReportFormsAnalysis.List },
  { key: 'report-forms-analysis-detail', path: '/report-forms-analysis/detail/:id', component: ReportFormsAnalysis.Detail },
  { key: 'overview', path: '/dashboard/overview', component: Dashboard.Overview },
  { key: 'situation', path: '/dashboard/situation', component: Dashboard.Situation },
  { key: 'sub-user', path: '/subuser', component: SubUser },
  { key: 'operation-log', path: '/operation-log', component: OperationLog },
  { key: 'open-service', path: '/openService', component: OpenService },
  { key: 'access-control-nat', path: '/access-control/nat', component: AccessControl.NatList },
]

// 无权限时菜单
export const noAuthRoutes: RouteItem[] = [
  { key: 'open-service', path: '/openService', component: OpenService }
]

export const getAuthMenu = (routes: any) => {
  // 当前用户是否有渠道管理菜单权限列表
  const authMenuArr = JSON.parse(window.localStorage.getItem('sdwan-authMenu') || '')
  if(authMenuArr && Array.isArray(authMenuArr)) {
    authMenuArr?.includes('channelPopServerPool') && routes.push({ key: 'pop-servers', path: '/channel/pop-servers/list', component: PopServers })
    authMenuArr?.includes('channelPrivateLinePool') && routes.push({ key: 'dedicated-line', path: '/channel/dedicated-line/list', component: PrivateLine })
    authMenuArr?.includes('channelUserNetTopology') && routes.push({ key: 'user-netTopology', path: '/channel/user-netTopology', component: NetTopology })
    authMenuArr?.includes('channelUserOrder') && routes.push({ key: 'user-order', path: '/channel/user-order', component: UserOrder })
    authMenuArr?.includes('channelCrossBorder') && routes.push({ key: 'cross-border', path: '/channel/crossBorder', component: CrossBorder })
    authMenuArr?.includes('channelProbeTask') && routes.push({ key: 'probe-task', path: '/channel/probeTask', component: DialTest })
    authMenuArr?.includes('channelUserOpLog') && routes.push({ key: 'operate-log', path: '/channel/operation-log', component: OpLog })
    authMenuArr?.includes('channelGaaList') && routes.push({ key: 'saas-list', path: '/channel/saasList', component: SaasAcceleration })
    authMenuArr?.includes('channelUserFlowLog') && routes.push({ key: 'flow-log', path: '/channel/userBehaviorLog', component: FlowLog })
}

  return routes
}

export default routes